/**
 * @generated SignedSource<<8168795e7838cc2e74dc196cbb9d4633>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RoutineDetailScreenQuery$variables = {
  fromDate?: string | null;
  id: string;
};
export type RoutineDetailScreenQuery$data = {
  readonly routine: {
    readonly id: string;
    readonly issueStats: {
      readonly " $fragmentSpreads": FragmentRefs<"IssueStatsCreatedGraph_IssueStats" | "IssueStatsTTRGraph_IssueStats" | "IssueStatsTopTypes_IssueStats">;
    };
    readonly " $fragmentSpreads": FragmentRefs<"RoutineDetailScreenTaskActivity_Routine" | "RoutineDetailScreenTopContributor_Routine" | "RoutineDetailScreenTopTaskIssueCreator_Routine">;
  } | null;
};
export type RoutineDetailScreenQuery = {
  response: RoutineDetailScreenQuery$data;
  variables: RoutineDetailScreenQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "fromDate"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v2 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "count",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v6 = [
  {
    "kind": "Variable",
    "name": "fromDate",
    "variableName": "fromDate"
  }
],
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v8 = [
  (v4/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "date",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "RoutineDetailScreenQuery",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "Routine",
        "kind": "LinkedField",
        "name": "routine",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "RoutineDetailScreenTopContributor_Routine"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "RoutineDetailScreenTopTaskIssueCreator_Routine"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "RoutineDetailScreenTaskActivity_Routine"
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "IssueStats",
            "kind": "LinkedField",
            "name": "issueStats",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "IssueStatsTopTypes_IssueStats"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "IssueStatsCreatedGraph_IssueStats"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "IssueStatsTTRGraph_IssueStats"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "RoutineDetailScreenQuery",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "Routine",
        "kind": "LinkedField",
        "name": "routine",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "RoutineUserContributor",
            "kind": "LinkedField",
            "name": "topContributors",
            "plural": true,
            "selections": [
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v5/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v6/*: any*/),
            "concreteType": "TaskSectionIssueStatNode",
            "kind": "LinkedField",
            "name": "topTaskSectionIssueCreators",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "RoutineSection",
                "kind": "LinkedField",
                "name": "section",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v7/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Team",
                    "kind": "LinkedField",
                    "name": "assignedTeam",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "icon",
                        "storageKey": null
                      },
                      (v5/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "task",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  },
                  (v3/*: any*/),
                  (v7/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "RoutineTaskActivityByHour",
            "kind": "LinkedField",
            "name": "taskActivityByHour",
            "plural": true,
            "selections": [
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hour",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "IssueStats",
            "kind": "LinkedField",
            "name": "issueStats",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "IssueStatTitleCountNode",
                "kind": "LinkedField",
                "name": "topIssueTitles",
                "plural": true,
                "selections": [
                  (v7/*: any*/),
                  (v4/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "IssuePerDateStat",
                "kind": "LinkedField",
                "name": "created",
                "plural": true,
                "selections": (v8/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "IssuePerDateStat",
                "kind": "LinkedField",
                "name": "resolved",
                "plural": true,
                "selections": (v8/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v6/*: any*/),
                "concreteType": "IssueTimeToResolveBucketed",
                "kind": "LinkedField",
                "name": "timeToResolveBucketed",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "bucketTimeSeconds",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "counts",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "total",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "bf5d4e3c4253eb0703f973f590dd9c03",
    "id": null,
    "metadata": {},
    "name": "RoutineDetailScreenQuery",
    "operationKind": "query",
    "text": "query RoutineDetailScreenQuery(\n  $id: ID!\n  $fromDate: String\n) {\n  routine(id: $id) {\n    id\n    ...RoutineDetailScreenTopContributor_Routine\n    ...RoutineDetailScreenTopTaskIssueCreator_Routine\n    ...RoutineDetailScreenTaskActivity_Routine\n    issueStats {\n      ...IssueStatsTopTypes_IssueStats\n      ...IssueStatsCreatedGraph_IssueStats\n      ...IssueStatsTTRGraph_IssueStats\n      id\n    }\n  }\n}\n\nfragment IssueStatsCreatedGraph_IssueStats on IssueStats {\n  created {\n    count\n    date\n  }\n  resolved {\n    count\n    date\n  }\n}\n\nfragment IssueStatsTTRGraph_IssueStats on IssueStats {\n  timeToResolveBucketed(fromDate: $fromDate) {\n    bucketTimeSeconds\n    counts\n    total\n  }\n}\n\nfragment IssueStatsTopTypes_IssueStats on IssueStats {\n  topIssueTitles {\n    title\n    count\n  }\n}\n\nfragment RoutineDetailScreenTaskActivity_Routine on Routine {\n  taskActivityByHour {\n    count\n    hour\n  }\n}\n\nfragment RoutineDetailScreenTopContributor_Routine on Routine {\n  topContributors {\n    count\n    user {\n      id\n      name\n    }\n  }\n}\n\nfragment RoutineDetailScreenTopTaskIssueCreator_Routine on Routine {\n  topTaskSectionIssueCreators(fromDate: $fromDate) {\n    id\n    section {\n      id\n      title\n      assignedTeam {\n        id\n        icon\n        name\n      }\n    }\n    count\n    task {\n      __typename\n      id\n      title\n      ... on TaskCheck {\n        __typename\n      }\n      ... on TaskNumber {\n        __typename\n      }\n      ... on TaskText {\n        __typename\n      }\n    }\n  }\n  id\n}\n"
  }
};
})();

(node as any).hash = "85397321d550776f391750b8119c267c";

export default node;
